import styles from "./PaddedDotLoader.module.scss";
import DotLoader from "../../../../common/core-ui/DotLoader.tsx";
import React from "react";

export default function PaddedDotLoader(
  props: React.ComponentProps<typeof DotLoader>
) {
  return <DotLoader {...props} className={styles.loader} />;
}
